import { SortTableBtnController } from "./sort-table-btn.controller";

angular
    .module("thor.shared.sort-table-btn.component", [])
    .component("sortTableBtn", {
        bindings: {
            sortParams: "=",
            sortType: "<"
        },
        controller: SortTableBtnController,
        template: require("./sort-table-btn.html")
    });
